class Store {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-tab-trigger li:first-child').addClass('active');
    $(".js-tab-inner ul:first-of-type").css("display", "block");
    let date = new Date();

    $('.js-change-date').html(`${date.getFullYear()}年 ${date.getMonth() + 1}月`)

    let swiper = new Swiper(".mySwiper", {
      initialSlide: $(`[data-year="${date.getFullYear()}"][data-month="${date.getMonth() + 1}"]`).index(),
      navigation: {
        nextEl: ".next-btn",
        prevEl: ".prev-btn",
      },
      spaceBetween: 50,
      speed: 500,
    });

    swiper.on('slideChangeTransitionStart', function () {
      $('.js-change-date').html($('.swiper-slide-active').data('date'));
    });

    const mvswiper = new Swiper('.mvSwiper', {
      slidesPerView: 1,
      loop:true,
      speed: 2000,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });


    $('.js-tab-trigger li').on('click', function() {
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
      let el_index = $(this).index();
      $('.js-tab-inner ul').fadeOut(300);
      setTimeout(function() {
        $('.js-tab-inner ul').eq(el_index).fadeIn(300);
      }, 300)
  
    })

  }
}